import { Box } from '@mui/material';
import ProfileDrawer from '@/layouts/private/components/ProfileDrawer';
import SiteFooter from '@/layouts/private/components/SiteFooter';
import { useUrlChecker } from '@/routing/useUrlChecker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SiteHeader from './components/site-header';
import SiteFooterPublic from './components/SiteFooterPublic';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { routes } from '@/constants/Constants';
import { ToastProvider } from '@/shared/components/Toast';
import { CoreWrapper } from '@/shared/session/guards';
import { SideMenuV1, useMenu } from '@/layouts/private/components/side-menu';
import { LayoutProvider } from '@/layouts/LayoutContext';
import { InviteLeaseDetailsDrawer } from '@/features/RenterInvite';
import { Outlet } from 'react-router';

interface Props {
  children?: React.ReactNode;
}

function InviteDrawerGate() {
  const { isPublic } = useUrlChecker();
  if (isPublic) {
    return null;
  }
  return <InviteLeaseDetailsDrawer />;
}

function PublicLayout({ children }: Props) {
  const { menuOpen } = useMenu();
  const { isPublic } = useUrlChecker();
  const preRegister = isPublic || window.location.pathname === routes.unitsOwnedEnroll;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <CoreWrapper>
        <ToastProvider>
          <LayoutProvider>
            <SiteHeader />
            {/* Viewheight minus header.*/}
            <div id="page-container" style={{ minHeight: 'calc(100vh - 148px)' }}>
              {preRegister ? null : <SideMenuV1 />}
              <Box
                sx={{
                  px: { xs: 2, md: isPublic ? 0 : 2 },
                  marginLeft: { md: isPublic ? '0px' : menuOpen ? '303px' : '80px' },
                  transition: 'margin 0.3s linear',
                }}
              >
                {/* Viewheight minus header and footer is page content */}
                <Box
                  sx={{
                    minHeight: preRegister
                      ? 'calc(100vh - 148px - 445px)'
                      : 'calc(100vh - 148px - 130px)',
                    width: '100%',
                    margin: { xl: '0 auto' },
                  }}
                >
                  {children ?? <Outlet />}
                </Box>
                {isPublic ? null : <SiteFooter />}
              </Box>
              {isPublic ? <SiteFooterPublic /> : null}
              <ProfileDrawer />
            </div>
            <InviteDrawerGate />
          </LayoutProvider>
        </ToastProvider>
      </CoreWrapper>
    </LocalizationProvider>
  );
}

export default PublicLayout;
